<template>
  <div v-if="cart" class="cart-overview">
    <dates-overview
      :cart="cart"
      :can-edit="canEdit"
      @edit="$emit('edit', $event)"
    />
    <room-overview
      v-for="(room, i) in cart.lines"
      :key="room.id"
      :room-index="i"
      :cart="cart"
      :can-edit="canEdit"
      @close="$emit('close')"
    />
    <taxes-overview
      :cart="cart"
    />
    <total-overview
      v-if="!withoutTotals"
      class="box final-total"
    />
    <div class="fine-print">
        {{tc('cart.myCart.finePrint')}}
    </div>    
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import DatesOverview from './dates-overview.vue'
import RoomOverview from './room-overview.vue'
import TaxesOverview from './taxes-overview.vue'
import TotalOverview from './cart-totals.vue'

export default {
  name: 'cart-overview',
  components: {
    DatesOverview,
    RoomOverview,
    TaxesOverview,
    TotalOverview
  },
  props: {
    withoutTotals: Boolean,
    canEdit: Boolean
  },
  computed: {
    ...mapState('cart', ['cart']),
    ...mapGetters('i18n', ['tc']),
  },
}
</script>